/// <reference path=skyward.ui.userpreference.js"/>
/// <reference path="skyward.ui.modallayer.js"/>
(
    function (skyward, $, undefined)
    {
        skyward.headerMenus = skyward.headerMenus || {};

        function myAccountPopupBuilder()
        {
            var button = $(this);
            var data = button.data();

            var menuItems = [{ type: "title", text: "My Options" }];

            if (data.changeMyPasswordIconCode)
            {
                menuItems.push(getMenuItem("Change Password",
                {
                    icon: data.changeMyPasswordIconCode,
                    target: "popup",
                    click: buildLoadContentClickFunction("popup", "Workflow", "WorkflowInstance", "Create/Security/User/ChangeMyPassword",
                        {
                            data:
                                {
                                    "Workflow.UserID": data.changeMyPasswordUserId,
                                    "Workflow.UserID_securityhash": data.changeMyPasswordUserId_securityhash
                                }
                        })
                }));
            }

            if (data.changeUsernameIconCode)
            {
                menuItems.push(getMenuItem("Change Username",
                {
                    icon: data.changeMyPasswordIconCode,
                    target: "popup",
                    click: buildLoadContentClickFunction("popup", "Workflow", "WorkflowInstance", "Create/Security/User/ChangeUsername",
                        {
                            data:
                                {
                                    "Workflow.UserID": data.changeUsernameUserId,
                                    "Workflow.UserID_securityhash": data.changeUsernameUserId_securityhash
                                }
                        })
                }));
            }

            if (data.impersonateUser)
            {
                menuItems.push(getMenuItem("Impersonate User",
                {
                    icon: data.impersonateUserIconCode,
                    click: buildLoadContentClickFunction("full", "Security", "User", "ImpersonateUser", { data: { "tab": data.impersonateUserTab } })
                }));
            }
            else if (data.stopUserImpersonation)
            {
                menuItems.push(getMenuItem("Stop User Impersonation",
                {
                    icon: data.stopUserImpersonationIconCode,
                    target: "popout",
                    click: buildLoadContentClickFunction("full", "Security", "User", "StopImpersonation")
                }));
            }

            // Once Facebook and Google logins are fixed, uncomment this:
            //if (data.linkedAccounts)
            //{
            //    menuItems.push(getMenuItem("Linked Accounts",
            //    {
            //        icon: data.linkedAccountsIconCode,
            //        click: buildLoadContentClickFunction("full", "Security", "User", "LinkedAccounts")
            //    }));
            //}

            if (data.themeSelectorIconCode && (!skyward.global.isIosApp && !skyward.global.isAndroidApp))
            {
                menuItems.push(getMenuItem("Themes",
                    {
                        icon: data.themeSelectorIconCode,
                        id: "themeSelector",
                        click: async function () { await skyward.themeSelector.build(this); },
                        role: "button",
                        hasPopup: "dialog",
                }));
            }

            if (data.userPreferencesIconCode && (!skyward.global.isIosApp && !skyward.global.isAndroidApp))
            {
                menuItems.push(getMenuItem("User Preferences",
                {
                    icon: data.userPreferencesIconCode,
                    id: data.userPreferencesPrimaryKeyValue,
                    click: buildLoadContentClickFunction("full", "Security", "UserPreference", "Details", { id: data.userPreferencesPrimaryKeyValue })
                }));
            }

            if ((skyward.global.isInHouse && skyward.global.isRealSuperUser) || skyward.global.isRealSupportAccount)
            {
                menuItems.push(getMenuItem("Support Tools",
                {
                    icon: "Build",
                    id: "supportTools",
                    click: function () { skyward.support.build(); },
                    role: "button",
                    hasPopup: "dialog"
                }));
            }

            skyward.modalLayer.showMenu(menuItems, "#" + button.attr('id'), {});
        }

        function knowledgeHubPopupBuilder()
        {
            var button = $(this);
            var data = button.data();

            var menuItems = [{ type: "title", text: "Knowledge Hub Options" }];

            if (data.showCommunity)
            {
                menuItems.push(getMenuItem("Community",
                {
                    icon: data.communityIconCode,
                    click: function ()
                    {
                        window.open(data.communityHref, "_blank");
                    }
                }));
            }

            menuItems.push(getMenuItem("Help Center",
            {
                icon: data.helpCenterIconCode,
                click: function ()
                {
                    window.open(data.helpCenterHref, "_blank");
                }
            }));

            if (data.showProductIdeas)
            {
                menuItems.push(getMenuItem("Product Ideas",
                {
                    icon: data.productIdeasIconCode,
                    click: function ()
                    {
                        window.open(data.productIdeasHref, "_blank");
                    }
                }));
            }

            if (data.showPdc)
            {
                menuItems.push(getMenuItem("Professional Development Center",
                {
                    icon: data.pdcIconCode,
                    click: function ()
                    {
                        window.open(data.pdcHref, "_blank");
                    }
                }));
            }

            if (data.showMyHubAccount) {
                menuItems.push(getMenuItem("My Hub Account",
                    {
                        icon: data.myHubAccountIconCode,
                        click: function () {
                            window.open(data.myHubAccountHref, "_blank");
                        }
                    }));
            }

            if (data.showRemoteAssistance) {
                menuItems.push(getMenuItem("Remote Assistance",
                    {
                        icon: data.remoteAssistanceIconCode,
                        id: "remoteAssistance",
                        click: function () {
                            window.open(data.remoteAssistanceHref, "_blank");
                        }
                    }));
            }

            menuItems.push(getMenuItem("About",
                {
                    icon: data.aboutPopupIconCode,
                    id: "about",
                    hasPopup: "dialog",
                    click: function () { skyward.aboutPopup.buildAboutPopup(); }
            }));

            skyward.modalLayer.showMenu(menuItems, "#" + button.attr('id'), {});
        }

        function getMenuItem(text, options)
        {
            var defaultSettings =
            {
                type: "item",
                id: null,
                click: null,
                target: "full",
                data: null,
                icon: null
            };

            var menuItem = $.extend({}, defaultSettings, options);
            menuItem.text = text;

            return menuItem;

        }

        function buildLoadContentClickFunction(target, module, object, screen, options)
        {
            var defaultSettings =
            {
                data: null,
                id: null,
            };
            var settings = $.extend({}, defaultSettings, options);
            return function ()
            {
                skyward.window.loadContent(target, module, object, screen, settings.id, settings.data);
            };
        }

        var init = function ()
        {
            var clickEvent = "click";
            // .off().on() is used because currently on workflow load loadDOM is called back twice with the selector to the entire workflow
            // without .off().on(), we would be adding the function twice
            $("#myAccountButton").off(clickEvent, myAccountPopupBuilder).on(clickEvent, myAccountPopupBuilder);
            $("#knowledgeHubButton").off(clickEvent, knowledgeHubPopupBuilder).on(clickEvent, knowledgeHubPopupBuilder);
        };

        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
